import React from "react";

const Home = () => {
  return (
    <div className="container-limited">
    <div className="home-container">
      {}
      <section className="hero-section">
        <div className="hero-content">
          <img src="/images/hero.png" alt="Sly Panda Logo" className="hero-logo" />
          <p className="text-lg mt-4 font-light">
            A software development studio based in the West of Scotland, specializing in game development and software engineering.
          </p>
        </div>
      </section>

      {}
      <section className="about-section max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold">Who We Are</h2>
        <div className="about-text">
          <p className="mt-6 text-lg">
            <strong>Our Story</strong> <p></p> Born amidst the rugged beauty of the West of Scotland, our journey began as a spark of childhood wonder—ignited by the magic of video games and an early fascination with technology. From late nights exploring virtual worlds to the thrill of solving real-world problems with code, we evolved from passionate gamers into dedicated software engineers. Today, our creative spirit drives us to craft not only immersive gaming experiences but also sophisticated automation systems and innovative software solutions that make everyday tasks more efficient and inspiring.
          </p>
          <hr className="separator" />
          <p className="mt-6 text-lg">
            <strong>Our Mission</strong> <p></p>We exist to fuse creativity with technology whether that’s building immersive games, automating workflows, or consulting on ambitious software projects. As a software development and consultancy studio, we partner with startups, SMEs, and enterprise teams to bring their ideas to life with clean code, sharp design, and battle-tested architecture. Our mission is to create digital products that are both intuitive and impactful.
          </p>
          <hr className="separator" />
          <p className="mt-6 text-lg">
            <strong>Our Vision</strong> <p></p> We see a future where software isn’t just functional, it’s inspiring. From interactive entertainment to enterprise tools, our goal is to push boundaries and redefine what’s possible through thoughtful design and engineering. By bridging our game development heritage with consultancy expertise, we aim to deliver smart solutions that drive progress for businesses and delight end-users.
          </p>
        </div>
      </section>

      {}

               <h1 className="text-3xl font-bold text-center mb-10">What We Do</h1>
      <section className="services-container">

                <div className="service-card">
          <img src="/images/gamejam.png" alt="Software Consulting" className="service-icon" />
          <h3 className="text-xl font-semibold mt-4">Software Consulting</h3>
          <p className="text-gray-600 mt-3 text-center">
            We work with businesses of all sizes to architect, build, and improve software systems. From project planning to code reviews, our consultancy services are tailored to meet your development goals.
          </p>
        </div>
        <div className="service-card">
          <img src="/images/vr.png" alt="VR Experiences" className="service-icon" />
          <h3 className="text-xl font-semibold mt-4">VR Experiences</h3>
          <p className="text-gray-600 mt-3 text-center">
            We’ve explored immersive worlds through VR, delivering unique experiences for platforms like Quest 2 and Pico 4.
          </p>
        </div>
                <div className="service-card">
          <img src="/images/mobile.png" alt="Mobile Games" className="service-icon" />
          <h3 className="text-xl font-semibold mt-4">Mobile Games</h3>
          <p className="text-gray-600 mt-3 text-center">
            We have successfully launched multiple Android games, focusing on intuitive controls and addictive gameplay.
          </p>
        </div>

      </section>

            <section className="consulting-banner bg-gray-100 py-10 text-center">
  <h2 className="text-3xl font-bold mb-4">Need a Development Partner?</h2>
  <p className="text-lg max-w-3xl mx-auto">
    Whether you're launching a new product, scaling a system, or just need an extra pair of senior dev hands? we’ve got the experience and expertise to get it done right. 
    Reach out to learn how Sly Panda Interactive can help your team ship smarter.
  </p>
        </section>

        <p></p>

      {}
      <section className="call-to-action">
        <h2 className="text-4xl font-bold">Join Us on Our Journey</h2>
        <p className="text-lg mt-6">
          Whether you're a gamer, developer, or investor, we invite you to be part of our story.
          Follow our updates, play our games, and witness firsthand the evolution of Sly Panda Interactive.
        </p>
        <a href="/contact">Get in Touch</a>
      </section>

      {}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Sly Panda Interactive. All Rights Reserved.</p>
      </footer>
    </div>
    <br></br>

    </div>);

};

export default Home;